
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLogin } from "./../../Utils/utils";

import Header from "./../../Header";
import HeaderLogout from "./../../HeaderLogout";


const PublicRoute = ({component: Component, ...rest}) => {
    return (
      // restricted = false meaning public route
      // restricted = true meaning restricted route
      <Route
        {...rest}
        render={(props) =>
          isLogin() ? (
            <div>
              <HeaderLogout />
              <Component {...props} />
            </div>
          ) : (
            <div>
              <Header />
              <Component {...props} />
            </div>
          )
        }
      />
    );
};

export default PublicRoute;